import { z } from 'zod';

var _EventType = /* @__PURE__ */ ((_EventType2) => {
  _EventType2["LISTING_PAGE_VISITED"] = "listing-page-visited";
  _EventType2["BUTTON_CLICKED"] = "button-clicked";
  return _EventType2;
})(_EventType || {});
var ScriptEvent;
((ScriptEvent2) => {
  ScriptEvent2.EventType = _EventType;
  ScriptEvent2.ListingPageVisitedEventSchema = z.object({
    type: z.literal("listing-page-visited" /* LISTING_PAGE_VISITED */),
    appId: z.string(),
    listingId: z.string(),
    foreignId: z.string(),
    url: z.string()
  });
  ScriptEvent2.ButtonClickedEventSchema = z.object({
    type: z.literal("button-clicked" /* BUTTON_CLICKED */),
    listingId: z.string().optional(),
    appId: z.string().optional(),
    foreignId: z.string().optional(),
    buttonLabel: z.string().optional(),
    mountType: z.union([z.literal("referred"), z.literal("native")])
  });
  ScriptEvent2.Validators = {
    ["listing-page-visited" /* LISTING_PAGE_VISITED */]: ScriptEvent2.ListingPageVisitedEventSchema,
    ["button-clicked" /* BUTTON_CLICKED */]: ScriptEvent2.ButtonClickedEventSchema
  };
})(ScriptEvent || (ScriptEvent = {}));

export { ScriptEvent, _EventType };
